import * as React from 'react'
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  useGetIdentity,
  DeleteWithConfirmButton,
  ReferenceField,
  FunctionField,
  TopToolbar,
  CreateButton,
} from 'react-admin'
import { Chip } from '@material-ui/core'
import { useTranslate } from 'ra-core'
import { MyPagination } from '../../MyPagination'
import StatusChip from '../../components/StatusChip'

const QuestionListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
)

const QuestionList = props => {
  const translate = useTranslate()
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const questionLabel = 'label.' + identity.country.toLowerCase()
  return (
    <List
      {...props}
      actions={<QuestionListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      pagination={<MyPagination />}
    >
      <Datagrid rowClick="show">
        <TextField source="id" sortByOrder="DESC" />
        <ReferenceField
          label={translate('surveys.resources.thematic')}
          source="thematicId"
          reference="thematics"
          link="show"
        >
          <TextField source={questionLabel} />
        </ReferenceField>
        <TextField
          source={questionLabel}
          label={translate('surveys.common.name')}
        />
        <FunctionField
          label={translate('surveys.campaigns.response_type')}
          render={record => (
            <Chip size="small" label={record.responseType} variant="outlined" />
          )}
        />
        <TextField source="country" />
        <FunctionField
          label={translate('surveys.common.status')}
          render={record => (
            <StatusChip
              value={record.status}
              activeLabel={translate('surveys.common.active')}
              inactiveLabel={translate('surveys.common.desactive')}
            />
          )}
        />
        <ShowButton />
        <DeleteWithConfirmButton cancel="Cancel" undoable={true} />
      </Datagrid>
    </List>
  )
}

export default QuestionList
